import React from 'react';
import { cn } from '@/lib/utils';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

export const KpiCard = ({ label, value, delta, deltaLabel, hint, icon: Icon, testId }) => {
  const positive = typeof delta === 'number' ? delta >= 0 : null;
  return (
    <div
      className="relative overflow-hidden rounded-lg border border-white/5 bg-[hsl(var(--surface-1))] p-5 shadow-[0_1px_0_hsl(0_0%_100%/0.04),0_10px_30px_hsl(0_0%_0%/0.35)]"
      data-testid={testId || 'kpi-card'}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wider text-[hsl(var(--text-3))]">{label}</span>
        {Icon && <Icon className="h-4 w-4 text-[hsl(var(--text-3))]" />}
      </div>
      <div className="mt-3 text-2xl md:text-3xl font-semibold tabular">{value}</div>
      <div className="mt-3 flex items-center gap-2">
        {delta != null && (
          <span
            className={cn(
              'inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs tabular',
              positive
                ? 'bg-[hsl(var(--primary))/0.12] text-[hsl(var(--primary))]'
                : 'bg-[hsl(var(--danger))/0.12] text-[hsl(var(--danger))]'
            )}
          >
            {positive ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
            {Math.abs(delta)}%
            {deltaLabel && <span className="text-[hsl(var(--text-3))]">{deltaLabel}</span>}
          </span>
        )}
        {hint && <span className="text-xs text-[hsl(var(--text-3))]">{hint}</span>}
      </div>
    </div>
  );
};
